import { I18n } from '@affine/i18n';

import type { CanvasSelectionItem } from '../components/ai-chat-content/type';

type CanvasSelectionRole = NonNullable<CanvasSelectionItem['role']>;

export function canvasSelectionTypeLabel(
  type: string,
  role?: CanvasSelectionRole
) {
  switch (type) {
    case 'affine:note':
      return I18n.t('com.streamlain.ai.context.canvas.type.note');
    case 'affine:paragraph':
      return I18n.t('com.streamlain.ai.context.canvas.type.text');
    case 'affine:list':
      return I18n.t('com.streamlain.ai.context.canvas.type.list');
    case 'affine:database':
      return I18n.t('com.streamlain.ai.context.canvas.type.database');
    case 'affine:table':
      return I18n.t('com.streamlain.ai.context.canvas.type.table');
    case 'affine:image':
      return I18n.t('com.streamlain.ai.context.canvas.type.image');
    case 'affine:attachment':
      return role === 'pdf'
        ? I18n.t('com.streamlain.ai.context.pdf')
        : I18n.t('com.streamlain.ai.context.canvas.type.file');
    case 'affine:embed-ai-chat':
      return I18n.t('com.streamlain.ai.context.canvas.type.ai-chat');
    case 'affine:frame':
      return I18n.t('com.streamlain.ai.context.canvas.type.frame');
    case 'connector':
      return I18n.t('com.streamlain.ai.context.canvas.type.connector');
    case 'shape':
      return I18n.t('com.streamlain.ai.context.canvas.type.shape');
    case 'text':
      return I18n.t('com.streamlain.ai.context.canvas.type.text');
    case 'group':
      return I18n.t('com.streamlain.ai.context.canvas.type.group');
    default:
      return null;
  }
}

export function canvasSelectionRoleLabel(role: CanvasSelectionRole) {
  switch (role) {
    case 'group':
      return I18n.t('com.streamlain.ai.context.canvas.type.group');
    case 'frame':
      return I18n.t('com.streamlain.ai.context.canvas.type.frame');
    case 'database':
      return I18n.t('com.streamlain.ai.context.canvas.type.database');
    case 'pdf':
      return I18n.t('com.streamlain.ai.context.pdf');
    case 'attachment':
      return I18n.t('com.streamlain.ai.context.canvas.type.file');
    case 'mindmap':
      return I18n.t('com.streamlain.ai.context.canvas.type.mindmap');
    default:
      return I18n.t('com.streamlain.ai.context.canvas.default');
  }
}

export function canvasSelectionKindLabel(item: CanvasSelectionItem) {
  const typeLabel = canvasSelectionTypeLabel(item.type, item.role);
  return typeLabel ?? canvasSelectionRoleLabel(item.role ?? 'object');
}
